"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _marked = require("marked");

/**
 * Tags any `<ol>` / `<ul>` whose every `<li>` contains nothing but a single
 * hyperlink AND which is immediately preceded by a paragraph (the "label" —
 * e.g. "Related Articles:", "Sources:", "See also:"). Matches on shape rather
 * than the heading text so it's robust to wording changes across agents.
 *
 * Lists with mixed content (link + description, plain text bullets, etc.) and
 * link-lists with no preceding paragraph are left untouched.
 */
function tagLinkListSections(html) {
  if (typeof DOMParser === 'undefined') {
    return html;
  }

  var wrapper = new DOMParser().parseFromString("<div>".concat(html, "</div>"), 'text/html').body.firstChild;

  if (!wrapper) {
    return html;
  }

  wrapper.querySelectorAll('p').forEach(function (p) {
    var _p$textContent;

    if (!((_p$textContent = p.textContent) !== null && _p$textContent !== void 0 ? _p$textContent : '').trim()) {
      return;
    }

    var next = p.nextElementSibling;

    if (!next || next.tagName !== 'OL' && next.tagName !== 'UL') {
      return;
    }

    var items = Array.from(next.children).filter(function (c) {
      return c.tagName === 'LI';
    });

    if (items.length === 0) {
      return;
    }

    var allBareLinks = items.every(function (li) {
      // Keep element children + any text node with non-whitespace content.
      var meaningful = Array.from(li.childNodes).filter(function (n) {
        var _n$textContent;

        if (n.nodeType === Node.ELEMENT_NODE) return true;
        if (n.nodeType === Node.TEXT_NODE) return ((_n$textContent = n.textContent) !== null && _n$textContent !== void 0 ? _n$textContent : '').trim() !== '';
        return false;
      });
      return meaningful.length === 1 && meaningful[0].nodeType === Node.ELEMENT_NODE && meaningful[0].tagName === 'A';
    });

    if (allBareLinks) {
      next.classList.add('forethought-agent__related-articles'); // Open each link in a new tab, with the standard safety attributes so
      // the linked page can't tamper with our window via `window.opener`.

      items.forEach(function (li) {
        var anchor = li.querySelector('a');

        if (anchor) {
          anchor.setAttribute('target', '_blank');
          anchor.setAttribute('rel', 'noopener noreferrer');
        }
      });
    }
  });
  return wrapper.innerHTML;
}

var TextComponent = function TextComponent(_ref) {
  var component = _ref.component;
  var raw = component.format === 'markdown' ? _marked.marked.parse(component.message) : component.message;
  var html = tagLinkListSections(raw);
  return (0, _preact.h)("div", {
    className: "forethought-agent__text",
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

var _default = TextComponent;
exports.default = _default;